const mainWrapper = document.querySelector('.connected-products');

if(!mainWrapper) return;

let option_wrappers = document.querySelectorAll('.product-variant-picker__pill-list');

    let selectedOptions = [];

    function replacePageContent(targetUrl) {
        

        fetch(targetUrl)
            .then(function(response) {
                // When the page is loaded convert it to text
                return response.text()
            })
            .then(function(html) {
                // Initialize the DOM parser
                let parser = new DOMParser();

                // Parse the text
                let fetchedPage = parser.parseFromString(html, "text/html");


                // replace url
                const nextState = { additionalInformation: 'Product change' };
                // This will create a new entry in the browser's history, without reloading
                window.history.pushState(nextState, document.title, document.url);
                // This will replace the current entry in the browser's history, without reloading
                window.history.replaceState(nextState, fetchedPage.title, targetUrl);

                
                //update page title
                document.title = fetchedPage.title;
                

                let scroll = window.scrollY;

                //disable scroll to prevent jumping
                window.addEventListener('scroll', function(event) {
                    event.preventDefault();
                });

                //gallery
                document.querySelector('.product-desktop-media').replaceWith(fetchedPage.querySelector('.product-desktop-media'));
                document.querySelector('.product-mobile-media').replaceWith(fetchedPage.querySelector('.product-mobile-media'));
                document.querySelector('product-modal').replaceWith(fetchedPage.querySelector('product-modal'));

                //product badges
                document.querySelector('.product-badges-wrapper').replaceWith(fetchedPage.querySelector('.product-badges-wrapper'));

                //header
                document.querySelector('.product-header-block__bottom').replaceWith(fetchedPage.querySelector('.product-header-block__bottom'));

                //price
                document.querySelector('.product-general-info-block.block-price').replaceWith(fetchedPage.querySelector('.product-general-info-block.block-price'));
                document.querySelector('.product-price').replaceWith(fetchedPage.querySelector('.product-price'));

                //breadcrumbs
                document.querySelector('product-breadcrumbs').replaceWith(fetchedPage.querySelector('product-breadcrumbs'));

                //title
                document.querySelector('.product-general-info-block h1').replaceWith(fetchedPage.querySelector('.product-general-info-block h1'));

                //variant picker
                document.querySelector('.product__content variant-picker')?.replaceWith(fetchedPage.querySelector('.product__content variant-picker'));
                

                //product form
                document.querySelector('product-form').replaceWith(fetchedPage.querySelector('product-form'));

                //product quantity
                document.querySelector('.product-quantity__wrap').replaceWith(fetchedPage.querySelector('.product-quantity__wrap'));

                //product stock
                document.querySelector('.product-stock').replaceWith(fetchedPage.querySelector('.product-stock'));

                
                document.querySelector('.filter-item__firmness-wrapper .filter-item__select--active')?.click();

                //re-enable scroll and scroll to initial position
                window.removeEventListener('scroll', function(event) {
                    event.preventDefault();
                });
                window.scrollTo(0, scroll);

            })
            .catch(function(err) {  
                console.log('Failed to fetch page: ', err);  
            });
    }


    function checkSelected() {
        selectedOptions = [];
        option_wrappers.forEach(option_wrapper => {
            let selected = option_wrapper.querySelector('.selected').dataset.option;
            selectedOptions.push(selected);
        });

        const result = connected_product_list.find(item => selectedOptions.every(selectedOption => item.title.includes(selectedOption)));

        // Extract the handle if a matching item was found
        const handle = result ? result.handle : null;

        replacePageContent(handle);
    }


    checkSelected();
    

    

    document.addEventListener('click', function(e){
        const target = e.target.closest(".pill");
        const target_wrapper = e.target.closest(".product-variant-picker__pill-list");
        if(target && !target.classList.contains('selected')){

            //remove previously selected
            target_wrapper.querySelector('.selected').classList.remove('selected');
            //remove previously selected
            target.classList.add('selected');

            checkSelected()
        }
    });

    

    